// extracted by mini-css-extract-plugin
export default {"content":"Verification_content__7BZGY","resendCode":"Verification_resendCode__bmtLT","tips":"Verification_tips__UCh1o","needHelp":"Verification_needHelp__YIz0c"};